import ajax from "@/lib/ajax";


// 获取部门列表
export async function GetUtcodeList(payload: any){
	let res = await ajax.get('/api/services/app/Utcode/GetUtcodeList', {params:payload})
	return res.data.result
}
// 新增部门
export async function InsertUtcode(payload: any){
	let res = await ajax.post('/api/services/app/Utcode/InsertUtcode', payload)
	return res.data.result
}
// 更新部门
export async function UpdateUtcodeById(payload: any){
	let res = await ajax.put('/api/services/app/Utcode/UpdateUtcodeById', payload)
	return res.data.result
}
// 删除部门
export async function DeleteUtcode(payload: any){
	let res = await ajax.delete('/api/services/app/Utcode/DeleteUtcode', {params:payload})
	return res.data.result
}
export async function QueryDrug(payload:any) {
	//药品列表
	let res = await ajax.post(`/api/services/app/Medicine/QueryDrug`,payload)
	return res.data.result
}
export async function QueryDepartmentByNameList(payload:any) {
	//根据类型获取部门列表
	let res = await ajax.post(`/api/services/app/Utcode/QueryDepartmentByNameList`, payload)
	return res.data.result
}
// 获取人员列表
export async function GetMancodeList(payload: any){
	let res = await ajax.get('/api/services/app/Mancode/GetMancodeList', {params:payload})
	return res.data.result
}
// 新增人员
export async function InsertMancode(payload: any){
	let res = await ajax.post('/api/services/app/Mancode/InsertMancode', payload)
	return res.data.result
}
// 更新人员
export async function UpdateMancodeById(payload: any){
	let res = await ajax.put('/api/services/app/Mancode/UpdateMancodeById', payload)
	return res.data.result
}
// 删除人员
export async function DeleteMancode(payload: any){
	let res = await ajax.put('/api/services/app/Mancode/DeleteMancode', {params:payload})
	return res.data.result
}


// 获取项目列表
export async function GetChkitemList(payload: any){
	let res = await ajax.get('/api/services/app/Chkitem/GetChkitemList', {params:payload})
	return res.data.result
}
// 新增项目
export async function InsertChkitem(payload: any){
	let res = await ajax.post('/api/services/app/Chkitem/InsertChkitem', payload)
	return res.data.result
}
// 更新项目
export async function UpdateChkitemById(payload: any){
	let res = await ajax.put('/api/services/app/Chkitem/UpdateChkitemById', payload)
	return res.data.result
}
// 删除项目
export async function DeleteChkitem(payload: any){
	let res = await ajax.delete('/api/services/app/Chkitem/DeleteChkitem', {params:payload})
	return res.data.result
}


// 获取耗材列表
export async function GetConsumables(payload: any){
	let res = await ajax.get('/api/services/app/Consumables/GetConsumables', {params:payload})
	return res.data.result
}
// 新增耗材
export async function CreateConsumables(payload: any){
	let res = await ajax.post('/api/services/app/Consumables/CreateConsumables', payload)
	return res.data.result
}
// 更新耗材
export async function EdiConsumables(payload: any){
	let res = await ajax.post('/api/services/app/Consumables/EdiConsumables', payload)
	return res.data.result
}
// 删除耗材
export async function DeleteConsumables(payload: any){
	let res = await ajax.put('/api/services/app/Consumables/DeleteConsumables', {params:payload})
	return res.data.result
}



// 新增项目组套
export async function CreateItemPackage(payload: any){
	let res = await ajax.post('/api/services/app/ItemPackage/CreateItemPackage', payload)
	return res.data.result
}
// 编辑项目组套
export async function EditItemSet(payload: any){
	let res = await ajax.post('/api/services/app/ItemPackage/EditItemSet', payload)
	return res.data.result
}
// 获取组套列表
export async function QueryItemSet(payload: any){
	let res = await ajax.post('/api/services/app/ItemPackage/QueryItemSet', payload)
	return res.data.result
}
// 获取组套详情
export async function QueryItemSetDetailInfo(payload: any){
	let res = await ajax.get('/api/services/app/ItemPackage/QueryItemSetDetailInfo', {params:payload})
	return res.data.result
}
// 删除组套
export async function DeleteItemSet(payload: any){
	let res = await ajax.delete('/api/services/app/ItemPackage/DeleteItemSet', {params:payload})
	return res.data.result
}
// 删除组套
export async function GetItemSetSelected(){
	let res = await ajax.get('/api/services/app/ItemPackage/GetItemSetSelected')
	return res.data.result
}



// 获取患者列表
export async function GetPatients(payload: any){
	let res = await ajax.get('/api/services/app/Patient/GetPatients', {params:payload})
	return res.data.result
}
// 查询患者病历首页
export async function GetPatAdmissionRecord(payload: any){
	let res = await ajax.get('/api/services/app/Patient/GetPatAdmissionRecord', {params:payload})
	return res.data.result
}
// 新增患者
export async function InsertPatient(payload: any){
	let res = await ajax.post('/api/services/app/Patient/InsertPatient', payload)
	return res.data.result
}
// 更新患者
export async function EditPatient(payload: any){
	let res = await ajax.post('/api/services/app/Patient/EditPatient', payload)
	return res.data.result
}
// 删除患者
export async function DeletePatient(payload: any){
	let res = await ajax.delete('/api/services/app/Patient/DeletePatient', {params:payload})
	return res.data.result
}



// 获取供货商列表
export async function GetGhscodeList(payload: any){
	let res = await ajax.get('/api/services/app/Ghscode/GetGhscodeList', {params:payload})
	return res.data.result
}
// 新增供货商
export async function InsertGhscode(payload: any){
	let res = await ajax.post('/api/services/app/Ghscode/InsertGhscode', payload)
	return res.data.result
}
// 更新供货商
export async function UpdateGhscodeById(payload: any){
	let res = await ajax.post('/api/services/app/Ghscode/UpdateGhscodeById', payload)
	return res.data.result
}
// 删除供货商
export async function DeleteGhscode(payload: any){
	let res = await ajax.delete('/api/services/app/Ghscode/DeleteGhscode', {params:payload})
	return res.data.result
}



// 获取病区列表
export async function GetWardList(payload: any){
	let res = await ajax.get('/api/services/app/Ward/GetWardList', {params:payload})
	return res.data.result
}
// 新增病区
export async function InsertWard(payload: any){
	let res = await ajax.post('/api/services/app/Ward/InsertWard', payload)
	return res.data.result
}
// 更新病区
export async function UpdateWardById(payload: any){
	let res = await ajax.put('/api/services/app/Ward/UpdateWardById', payload)
	return res.data.result
}
// 删除病区
export async function DeleteWard(payload: any){
	let res = await ajax.delete('/api/services/app/Ward/DeleteWard', {params:payload})
	return res.data.result
}



// 获取病区列表
export async function GetShiftList(payload: any){
	let res = await ajax.get('/api/services/app/Shift/GetShiftList', {params:payload})
	return res.data.result
}
// 新增病区
export async function InsertShift(payload: any){
	let res = await ajax.post('/api/services/app/Shift/InsertShift', payload)
	return res.data.result
}
// 更新病区
export async function UpdateShiftById(payload: any){
	let res = await ajax.put('/api/services/app/Shift/UpdateShiftById', payload)
	return res.data.result
}
// 删除病区
export async function DeleteShift(payload: any){
	let res = await ajax.delete('/api/services/app/Shift/DeleteShift', {params:payload})
	return res.data.result
}


// 获取床位列表
export async function GetBedList(payload: any){
	let res = await ajax.get('/api/services/app/Bed/GetBedList', {params:payload})
	return res.data.result
}
// 新增床位
export async function InsertBed(payload: any){
	let res = await ajax.post('/api/services/app/Bed/InsertBed', payload)
	return res.data.result
}
// 更新床位
export async function UpdateBedById(payload: any){
	let res = await ajax.put('/api/services/app/Bed/UpdateBedById', payload)
	return res.data.result
}
// 删除床位
export async function DeleteBed(payload: any){
	let res = await ajax.delete('/api/services/app/Bed/DeleteBed', {params:payload})
	return res.data.result
}


// 透析机厂家相关
export async function GetMachineChangJList(payload: any){
	let res = await ajax.get('/api/services/app/MachineChangJ/GetMachineChangJList', {params:payload})
	return res.data.result
}
export async function InsertMachineChangJ(payload: any){
	let res = await ajax.post('/api/services/app/MachineChangJ/InsertMachineChangJ', payload)
	return res.data.result
}
export async function UpdateMachineChangJById(payload: any){
	let res = await ajax.put('/api/services/app/MachineChangJ/UpdateMachineChangJById', payload)
	return res.data.result
}
export async function DeleteMachineChangJ(payload: any){
	let res = await ajax.delete('/api/services/app/MachineChangJ/DeleteMachineChangJ', {params:payload})
	return res.data.result
}


// 透析机厂家型号相关
export async function GetMachineModelList(payload: any){
	let res = await ajax.get('/api/services/app/MachineModel/GetMachineModelList',{params:payload})
	return res.data.result
}
export async function InsertMachineModel(payload: any){
	let res = await ajax.post('/api/services/app/MachineModel/InsertMachineModel', payload)
	return res.data.result
}
export async function UpdateMachineModelById(payload: any){
	let res = await ajax.put('/api/services/app/MachineModel/UpdateMachineModelById', payload)
	return res.data.result
}
export async function DeleteMachineModel(payload: any){
	let res = await ajax.delete('/api/services/app/MachineModel/DeleteMachineModel', {params:payload})
	return res.data.result
}




// WEBPACK FOOTER //
// ./src/api/specialDictionary/index.ts